import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../../configuration.service';
import {
    IFeedbackConfigs,
    IOnBoardingConfig,
    IStorytellingTechniqueConfig,
    IToneOfVoiceConfig,
    IVideoTagsConfig,
} from '../../../models/defines';
import { IAvailableFont, IFontsConfigs } from '../../../models/configs/fonts.model';
import {
    IBGMusic,
    IBGMusicGroup,
    IBGMusicGroupMeta,
    IBGMusicLibraryPage,
} from '../../../models/configs/background-music.model';
import { IAiVoiceConfigs } from '../../../models/ai-voice.model';
import { IAiAvatarConfigs } from '../../../models/ai-avatar-model';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationAuthApiService {
    path = '/auth/config';

    constructor(
        private http: HttpClient,
        private config: ConfigurationService
    ) {}

    getOnboardingConfig() {
        return this.http.get<IOnBoardingConfig>(`${this.config.apiIP + this.path}/onboarding`).toPromise();
    }

    getVideoTagsConfig() {
        return this.http.get<IVideoTagsConfig>(`${this.config.apiIP + this.path}/video_tags`).toPromise();
    }

    getTonesConfig() {
        return this.http.get<IToneOfVoiceConfig>(`${this.config.apiIP + this.path}/tone_of_voice`).toPromise();
    }

    getStorytellingTeqniquesConfig() {
        return this.http
            .get<IStorytellingTechniqueConfig>(`${this.config.apiIP + this.path}/storytelling_techniques`)
            .toPromise();
    }

    getFeedbackConfig() {
        return this.http.get<IFeedbackConfigs>(`${this.config.apiIP + this.path}/feedback_forms`).toPromise();
    }

    getFonts$() {
        return this.http.get<IFontsConfigs>(`${this.config.apiIP + this.path}/fonts`);
    }

    getAvailableFonts$() {
        return this.http.get<IAvailableFont[]>(`${this.config.apiIP + this.path}/available_fonts`);
    }

    getBGMusic$() {
        return this.http.get<IBGMusic[]>(`${this.config.apiIP + this.path}/music-library`);
    }

    getBGMusicGroups$(page: number = 0, limit: number = 5) {
        return this.http.get<IBGMusicLibraryPage>(`${this.config.apiIP + this.path}/music-library`, {
            params: { page: String(page), limit: String(limit) },
        });
    }

    getAllBGMusicGroupsMeta$() {
        return this.http.get<IBGMusicGroupMeta[]>(`${this.config.apiIP + this.path}/music-library/list`);
    }

    getBGMusicGroupByName$(name: string) {
        return this.http.get<IBGMusicGroup>(
            `${this.config.apiIP + this.path}/music-library/group/${encodeURIComponent(name)}`
        );
    }

    getAiVoicesOptionsConfig() {
        return this.http.get<IAiVoiceConfigs>(`${this.config.apiIP + this.path}/ai_voice_options`);
    }

    getAiAvatarOptionsConfig() {
        return this.http.get<IAiAvatarConfigs>(`${this.config.apiIP + this.path}/ai_avatar_options`);
    }
}
